import { FullRouteNavItem, NavItem } from '../models/nav-item.model';
import { buildFullRouteNavItems } from '../utils/navbar.utils';

const navItems: NavItem[] = [
  {
    displayName: 'Stock',
    faIconName: 'fa-cart-shopping',
    route: 'stock',
    children: [
      { displayName: 'Journal', route: 'journal' },
      { displayName: 'Locations', route: 'locations' },
      { displayName: 'Plants', route: 'plants' },
      { displayName: 'Product Categories', route: 'product-categories' },
      { displayName: 'Product Groups', route: 'product-groups' },
      { displayName: 'Quantity Unit Groups', route: 'quantity-unit-groups' },
      { displayName: 'Quantity Units', route: 'quantity-units' },
      { displayName: 'Recipes', route: 'recipes' },
      { displayName: 'Seeds', route: 'seeds', queryParams: { livingPlants: true } },
      { displayName: 'Shopping Lists', route: 'shopping-lists' },
      { displayName: 'Shopping Sessions', route: 'shopping-sessions' },
      { displayName: 'Stores', route: 'stores' },
    ],
  },
  {
    displayName: 'Stats',
    faIconName: 'fa-chart-line',
    route: 'stats',
    children: [
      { displayName: 'Consumption', route: 'consumption' },
      { displayName: 'Harvests', route: 'harvests' },
      { displayName: 'Spendings', route: 'spendings' },
      { displayName: 'Stock Value', route: 'stock-value' },
    ],
  },
  {
    displayName: 'Weather',
    faIconName: 'fa-cloud-sun',
    route: 'weather',
    children: [
      { displayName: 'Daily', route: 'daily' },
      { displayName: 'Hourly', route: 'hourly' },
    ],
  },

  {
    displayName: 'Fitness',
    faIconName: 'fa-heart-pulse',
    route: 'fitness',
    permission: 'user:fitness',
  },
];

export const fullRouteNavItems: FullRouteNavItem[] = buildFullRouteNavItems(navItems);
